import { Tipologia } from './../../../../../../models/tipologias.model';

export class ActualizarDepartamentoMunicipio{
  bienCulturalUuid: string
  gestionesUuid: string[]
  nuevoDepartamento: Tipologia
  nuevoMunicipio: Tipologia
  cambioNoRegistro: boolean
}